<div class="basicrow">
    <div class="container">
        <div class="autowcont m-top-i">
            <div class="basicrow msidespad">
                <div class="b-title">
                    <div class="autocont f-black roboto-m f-bmed pull-left vcenter">
                        <div class="tabcell">
                            Opciones de Pago
                        </div>
                    </div>
                </div>
            </div>
            <div class="basicrow msidespad m-top-u-i">
                <div class="balancesptr-i refdef text-center">
                    <span class="roboto-b" *ngIf="this.type=='postpaid' || this.type=='fixed'">
                        Descuentos Disponibles
                    </span>
                    <span class="roboto-b" *ngIf="this.type=='prepaid'">
                        Creditos Disponibles
                    </span>
                    <br />
                    <span class="f-blue f-lsemi roboto-b" *ngIf="this.type=='postpaid' || this.type=='prepaid'">{{this.totalCredit|currency}}</span>
                    <span class="f-blue f-lsemi roboto-b" *ngIf="this.type=='fixed'">{{this.totalCreditFixed}}%</span>
                </div>
                <div class="basicrow m-bott visible-xs">
                    <div class="logline full"></div>
                </div>
                <div class="balancesptr-iii refdef" *ngIf="this.type=='postpaid'">
                    <label class="label-r roboto-b">Monto de Descuento a Aplicar (&#36;)</label>
                    <div class="basicrow rel">
                        <img matTooltipShowDelay="500" matTooltipHideDelay="500" mat-raised-button matTooltip="Deberá tener este monto disponible en sus descuentos" class="q-t" width="100%" src="../../assets/images/tooltip1.png">
                        <input value="{{this.credito}}" class="inp-f payup qt" disabled>
                        <a (click)="this.evaluateDescent()" id="btnApply" class="btns payup vcenter cursorP" [ngClass]="{'blue': this.validDiscount  == true && this.billBalanceField > 0 && this.cr=='','gray':this.validDiscount  == false || this.billBalanceField == 0 || this.cr=='CR'}">
                            <span class="tabcell">
                                Aplicar&nbsp;&nbsp;<i class="fa fa-angle-right" aria-hidden="true"></i>
                            </span>
                        </a>
                    </div>
                </div>
                <div class="balancesptr-iii refdef" *ngIf="this.type=='prepaid'">
                    <label class="label-r roboto-b">Monto de Descuento a Aplicar (&#36;)</label>
                    <div class="basicrow rel">
                        <img matTooltipShowDelay="500" matTooltipHideDelay="500" mat-raised-button matTooltip="Monto Minimo Requerido para aplicar descuento en la modalidad de prepago." class="q-t" width="100%" src="../../assets/images/tooltip1.png">
                        <input value="{{this.credito}}" class="inp-f payup qt" disabled>
                        <a (click)="this.evaluateDescent()" id="btnApply" class="btns payup vcenter cursorP" [ngClass]="{'blue': this.validDiscount  == true,'gray':this.validDiscount  == false }">
                            <span class="tabcell">
                                Aplicar&nbsp;&nbsp;<i class="fa fa-angle-right" aria-hidden="true"></i>
                            </span>
                        </a>
                    </div>
                </div>
                <div class="balancesptr-iii refdef fixed" *ngIf="this.type=='fixed'">
                    <div class="basicrow rel ajuste-top1">
                        <img matTooltipShowDelay="500" matTooltipHideDelay="500" mat-raised-button matTooltip="El monto aplicable de descuento es el 50% de su plan." class="q-t2" width="100%" src="../../assets/images/tooltip1.png">
                        <a (click)="this.evaluateDescent()" class="btns  payup2 vcenter" [ngClass]="{'gray': this.credito  == 0,'blue':this.credito  > 0}">
                            <span class="tabcell">
                                Aplicar a Renta Mensual &nbsp;&nbsp;<i class="fa fa-angle-right" aria-hidden="true"></i>
                            </span>
                        </a>
                    </div>
                </div>

                <div class="balancesptr-iii refdef no-brd">
                    <label class="label-r roboto-b" *ngIf="this.type=='postpaid' || this.type=='fixed'">Monto a Pagar (&#36;)</label>
                    <label class="label-r roboto-b" *ngIf="this.type=='prepaid'">Monto a Recargar (&#36;)</label>
                    <div class="basicrow rel">
                        <img *ngIf="this.type=='postpaid' || this.type=='fixed'" matTooltipShowDelay="500" matTooltipHideDelay="500" mat-raised-button matTooltip="Ahora puedes abonar hasta $800.00. Si la cantidad indica CR, significa que usted tiene crédito en su cuenta" class="q-t"
                            width="100%" src="../../assets/images/tooltip1.png">
                        <img *ngIf="this.type=='prepaid'" matTooltipShowDelay="500" matTooltipHideDelay="500" mat-raised-button matTooltip="Ahora puedes recargar hasta $150.00. El monto minimo de la recarga es de $5.00" class="q-t" width="100%" src="../../assets/images/tooltip1.png">
                        <input type="type" [(ngModel)]="this.amountPayable" value="{{this.amountPayable}}" class="inp-f payup qt" />

                      <a *ngIf="this.type=='postpaid' || this.type=='fixed'" (click)="this.doPayment()" id="btnPay" class="btns payup vcenter cursorP" [ngClass]="{'gray': this.amountPayable  < 5 ||  this.amountPayable  > 2000,'red':this.amountPayable  >= 5 && this.amountPayable  <= 2000}">
                            <span class="tabcell">
                                Pagar&nbsp;&nbsp;<i class="fa fa-angle-right" aria-hidden="true"></i>
                            </span>
                        </a>

                      <a (click)="this.recharge()"  *ngIf="this.type=='prepaid'" id="btnPay" class="btns payup vcenter cursorP" [ngClass]="{'gray': this.amountPayable  < 5 ||  this.amountPayable  > 150,'red':this.amountPayable  >= 5 && this.amountPayable  <= 150}">
                            <span class="tabcell">
                                Recargar&nbsp;&nbsp;<i class="fa fa-angle-right" aria-hidden="true"></i>
                            </span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
